import { render } from "./sh-phonelogin.vue?vue&type=template&id=f3f84374&scoped=true"
import script from "./sh-phonelogin.vue?vue&type=script&lang=js"
export * from "./sh-phonelogin.vue?vue&type=script&lang=js"

import "./sh-phonelogin.vue?vue&type=style&index=0&id=f3f84374&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\ahuview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3f84374"]])

export default __exports__